import React, { useState, useEffect } from 'react';
import { useForm, ValidationError } from '@formspree/react';

const socialLinks = [
  { name: 'Email', url: 'mailto:manalkhan7@gmail.com' },
  { name: 'LinkedIn', url: 'https://linkedin.com/in/manalkhan07' },
  { name: 'Instagram', url: 'https://instagram.com/manalkhaan07' },
  { name: 'Flickr', url: 'https://www.flickr.com/photos/129260672@N02' },
  { name: 'Substack', url: 'https://substack.com/@khanmanal' },
];

const inputStyle = {
  width: '100%',
  border: '0.5px solid #e0ddd8',
  borderRadius: '2px',
  padding: '10px 12px',
  fontSize: '13px',
  fontFamily: 'Inter, sans-serif',
  color: '#1a1a1a',
  backgroundColor: '#ffffff',
  outline: 'none',
  lineHeight: 1.5,
};

const labelStyle = {
  display: 'block',
  fontSize: '11px',
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  color: '#6b6b6b',
  marginBottom: '6px',
  fontFamily: 'Inter, sans-serif',
};

const Contact = () => {
  const [state, handleSubmit] = useForm('xrbaozpl');
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [showThankYou, setShowThankYou] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('contactFormSubmitted') === 'true') setShowThankYou(true);
  }, []);

  useEffect(() => {
    if (state.succeeded) {
      setShowThankYou(true);
      localStorage.setItem('contactFormSubmitted', 'true');
    }
  }, [state.succeeded]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <section
      id="contact"
      className="bg-bg-primary"
      style={{ borderBottom: "0.5px solid #e0ddd8" }}
    >
      {/* Contact bar */}
      <div
        className="flex items-center justify-between px-10 py-8"
        style={{ borderBottom: "0.5px solid #e0ddd8" }}
      >
        <p className="font-playfair text-ink" style={{ fontSize: "18px" }}>
          Open to collaboration.
        </p>
        <div className="flex gap-6">
          <a
            href="mailto:manalkhan7@gmail.com"
            className="font-inter text-muted hover:text-ink transition-colors duration-200"
            style={{
              fontSize: "12px",
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              borderBottom: "0.5px solid #e0ddd8",
              paddingBottom: "1px",
            }}
          >
            Email
          </a>
          <a
            href="https://linkedin.com/in/manalkhan07"
            target="_blank"
            rel="noopener noreferrer"
            className="font-inter text-muted hover:text-ink transition-colors duration-200"
            style={{
              fontSize: "12px",
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              borderBottom: "0.5px solid #e0ddd8",
              paddingBottom: "1px",
            }}
          >
            LinkedIn
          </a>
          <a
            href="/Manal_Resume.docx"
            download="ManalKhan_CV.pdf"
            className="font-inter text-muted hover:text-ink transition-colors duration-200"
            style={{
              fontSize: "12px",
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              borderBottom: "0.5px solid #e0ddd8",
              paddingBottom: "1px",
            }}
          >
            Download CV
          </a>
        </div>
      </div>

      {/* Form + social */}
      <div className="grid md:grid-cols-2" style={{ borderBottom: "none" }}>
        {/* Form */}
        <div
          className="px-10 py-8"
          style={{ borderRight: "0.5px solid #e0ddd8", position: "relative" }}
        >
          <span className="section-label">Send a Message</span>

          {showThankYou ? (
            <div className="py-12 text-center">
              <p
                className="font-playfair text-ink mb-2"
                style={{ fontSize: "18px" }}
              >
                Thank you.
              </p>
              <p className="text-muted" style={{ fontSize: "13px" }}>
                I'll be in touch soon.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="name" style={labelStyle}>
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                />
                <ValidationError
                  prefix="Name"
                  field="name"
                  errors={state.errors}
                  className="text-red-500 text-xs mt-1"
                />
              </div>
              <div>
                <label htmlFor="email" style={labelStyle}>
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                />
                <ValidationError
                  prefix="Email"
                  field="email"
                  errors={state.errors}
                  className="text-red-500 text-xs mt-1"
                />
              </div>
              <div>
                <label htmlFor="subject" style={labelStyle}>
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                />
                <ValidationError
                  prefix="Subject"
                  field="subject"
                  errors={state.errors}
                  className="text-red-500 text-xs mt-1"
                />
              </div>
              <div>
                <label htmlFor="message" style={labelStyle}>
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={6}
                  style={{ ...inputStyle, resize: "none" }}
                />
                <ValidationError
                  prefix="Message"
                  field="message"
                  errors={state.errors}
                  className="text-red-500 text-xs mt-1"
                />
              </div>
              <button
                type="submit"
                disabled={state.submitting}
                className="font-inter text-white transition-opacity duration-200 disabled:opacity-50"
                style={{
                  backgroundColor: "#993C1D",
                  border: "none",
                  borderRadius: "2px",
                  padding: "10px 24px",
                  fontSize: "11px",
                  letterSpacing: "0.14em",
                  textTransform: "uppercase",
                  cursor: "pointer",
                }}
              >
                {state.submitting ? "Sending…" : "Send Message"}
              </button>
            </form>
          )}
        </div>

        {/* Social + info */}
        <div className="px-10 py-8">
          <span className="section-label">Connect</span>
          <div className="space-y-3 mb-8">
            {socialLinks.map((link) => (
              <a
                key={link.name}
                href={link.url}
                target={link.url.startsWith("mailto") ? undefined : "_blank"}
                rel="noopener noreferrer"
                className="block font-inter text-muted hover:text-ink transition-colors duration-200"
                style={{
                  fontSize: "12px",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                }}
              >
                {link.name}
              </a>
            ))}
          </div>
          <p
            className="text-muted"
            style={{ fontSize: "13px", lineHeight: 1.7 }}
          >
            Based in{" "}
            <strong className="text-ink font-medium">
              Toronto, Ontario, Canada
            </strong>
            . Available for lecturer positions, curatorial roles, and strategic
            communications projects globally.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
